module.exports = __webpack_public_path__ + "img/dj1.ebb772d7.png";